<sc-flex fitHeight stretchContent vertical>
    <div class="filter no-field-space" [formGroup]="formGroup">
        <sc-flex>
            <sc-date-field-legacy formControlName="dateFrom" labelDictionaryKey="tmc-visit.ui.export-visit-history.date-from"></sc-date-field-legacy>
            <sc-content-spacer></sc-content-spacer>
            <sc-date-field-legacy formControlName="dateUntil" labelDictionaryKey="tmc-visit.ui.export-visit-history.date-until"></sc-date-field-legacy>
            <sc-content-spacer></sc-content-spacer>
            <sc-string-field formControlName="query" labelDictionaryKey="tmc-visit.ui.export-visit-history.query"></sc-string-field>
            <sc-content-spacer></sc-content-spacer>
            <sc-button dictionaryKey="tmc-visit.common.action.show" (click)="showDetails()"></sc-button>
            <sc-content-spacer></sc-content-spacer>
            <sc-button dictionaryKey="tmc-visit.common.action.export" (click)="createExcel()" primary></sc-button>
        </sc-flex>
    </div>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex-fitting-content vertical>
        <sc-content-area fitHeight>
            <sc-scroll-pane>
                <table mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.createdAt"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.createdAt | timestamp }} </td>
                    </ng-container>

                    <ng-container matColumnDef="dayOfWeek">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.dayOfWeek"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.dayOfWeek}} </td>
                    </ng-container>

                    <ng-container matColumnDef="company">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.company"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.company}} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.name"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="arrivedAt">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.arrivedAt"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.arrivedAt | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="allDay">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.allDay"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.allDay | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="visitedPerson">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.visitedPerson"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.visitedPerson}} </td>
                    </ng-container>

                    <ng-container matColumnDef="instructionsDone">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.instructionsDone"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.instructionsDone | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="instructionFinish">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.instructionFinishDate"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.instructionFinishDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="entranceAllowedWithoutGuide">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.entranceAllowedWithoutGuide"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.entranceAllowedWithoutGuide | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.phone"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.phone}} </td>
                    </ng-container>

                    <ng-container matColumnDef="entranceAllowedByCar">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.entranceAllowedByCar"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.entranceAllowedByCar | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="numberPlate">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.numberPlate"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.numberPlate}} </td>
                    </ng-container>

                    <ng-container matColumnDef="chip">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.chip"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.chip | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="chipNumber">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.chipNumber"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.chipNumber}} </td>
                    </ng-container>

                    <ng-container matColumnDef="terminalRegistration">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.terminalRegistrationDate"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.terminalRegistrationDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="access">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.accessDate"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.accessDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.leaveDate"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.leaveDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="accessGuidedBy">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.accessGuidedBy"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.accessGuidedBy}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leaveGuidedBy">
                        <th mat-header-cell *matHeaderCellDef>
                          <sc-dictionary-label dictionaryKey="tmc-visit.entity.visithistory.leaveGuidedBy"></sc-dictionary-label>
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.leaveGuidedBy}} </td>
                    </ng-container>

                    <ng-container matColumnDef="filler">
                        <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
                        <td mat-cell *matCellDef="let transport"> &nbsp;</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let visitor; columns: columnsToDisplay"></tr>
                </table>
            </sc-scroll-pane>
        </sc-content-area>

    </sc-flex-fitting-content>
</sc-flex>
